import React, { useState } from "react";

const INITIAL_DESTINATIONS = [
  { name: "Ibiza", status: "LIVE", season: "May - October", description: "Balearic house music and club culture." },
  { name: "Marbella", status: "LIVE", season: "May - September", description: "Pool parties, beach clubs and arena shows." },
  { name: "London", status: "LIVE", season: "All year", description: "HLT in-house events and community nights." },
  { name: "Malta", status: "COMING SOON", season: "2026", description: "Mediterranean event programme in development." },
  { name: "Amsterdam", status: "COMING SOON", season: "ADE and beyond", description: "Amsterdam listings and travel packages." },
];

export default function AdminDestinations() {
  const [destinations, setDestinations] = useState(INITIAL_DESTINATIONS);

  function updateDestination(index, field, value) {
    setDestinations((current) =>
      current.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [field]: value } : item
      )
    );
  }

  return (
    <div className="page space-y-6">
      <section className="card">
        <h1 className="font-display text-3xl md:text-4xl">Destinations</h1>
        <p className="mt-1 text-slate-300">
          Frontend management screen for destination status copy. Persistence needs the backend
          destinations endpoint from the next backend pass.
        </p>
      </section>

      <section className="grid gap-4">
        {destinations.map((destination, index) => (
          <article key={destination.name} className="card">
            <div className="grid gap-4 md:grid-cols-[180px,1fr,160px] md:items-start">
              <div>
                <h2 className="text-xl font-semibold text-white">{destination.name}</h2>
                <span className="badge mt-2">{destination.status}</span>
              </div>

              <div className="grid gap-3">
                <label>
                  <span className="mb-1 block text-[11px] uppercase tracking-wider text-slate-400">
                    Season
                  </span>
                  <input
                    className="input"
                    value={destination.season}
                    onChange={(e) => updateDestination(index, "season", e.target.value)}
                  />
                </label>
                <label>
                  <span className="mb-1 block text-[11px] uppercase tracking-wider text-slate-400">
                    Description
                  </span>
                  <input
                    className="input"
                    value={destination.description}
                    onChange={(e) => updateDestination(index, "description", e.target.value)}
                  />
                </label>
              </div>

              <select
                className="input"
                value={destination.status}
                onChange={(e) => updateDestination(index, "status", e.target.value)}
              >
                <option>LIVE</option>
                <option>COMING SOON</option>
              </select>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
